
import { computed, defineComponent, onBeforeMount, ref } from 'vue';
import { deviceTypeEnquire } from '@/utils/device-type';
import { DeviceType } from '@/utils/device-type/types';
import { ConfigProvider } from 'ant-design-vue';
import { useAppStore } from './store/resources/app';
import 'animate.css';

export default defineComponent({
  name: 'App',
  components: {
    ConfigProvider,
  },
  setup() {
    const appStore = useAppStore();
    // 站点所需的数据是否初始化完毕 (设备类型监听器, ...)
    const initSiteDataComplete = ref(false);
    // store 数据是否初始化完毕 (用户数据, 多语言数据, ...)
    const initStoreDataComplete = computed(() => appStore.initDataComplete);

    // 初始化站点数据
    const initSiteData = async () => {
      // 当屏幕宽度发生变化, 修改 store 中设备类型(pc, desktop, mobile)
      deviceTypeEnquire((deviceType: DeviceType) => {
        appStore.updateDeviceType(deviceType);
      });

      initSiteDataComplete.value = true;
    };

    onBeforeMount(() => {
      initSiteData();
    });

    return {
      initStoreDataComplete,
      initSiteDataComplete,
    };
  },
});
